import React, {useContext} from "react";
import parse from "html-react-parser";
import {RecordsManagementContext} from "../StatesMangement/InitialiseContext";

const InfoLine = ({label, value}) => (
    <div className='ncbol-top-line'><span className='ncbol-top-label'>{label}</span> {value || 'N/A'}</div>
);

export default () => {
    let page = useContext(RecordsManagementContext).IV3_PageDetails || {};
    let summary = page.NcBolSummaryData || {};
    let important = page.NcBolImportantData || {};

    return (
        <div className='ncbol-top-wrap mt-2'>
            <div className='ncbol-top-left'>
                <InfoLine label='CARRIER ADDRESS:' value={summary.carrier_address}/>
                <InfoLine label='CARRIER PHONE#:' value={summary.carrier_phone}/>
                <InfoLine label='CREW NAMES:' value={summary.crew_names}/>
            </div>

            <div className='ncbol-top-center'>
                <div className='ncbol-top-title'>
                    {important.ncuc_title_text ? parse(`${important.ncuc_title_text}`) : 'NCUC UNIFORM HOUSEHOLD GOODS BILL OF LADING'}
                </div>
                <div className='ncbol-top-questions'>
                    {parse(important.ncuc_questions_text) || ''}
                </div>
            </div>

            <div className='ncbol-top-right'>
                <div className='ncbol-top-line text-right'><span className='ncbol-top-label'>CARRIER C#:</span> {summary.carrier_certificate || ''}</div>
                <div className='ncbol-top-line text-right'><span className='ncbol-top-label'>CARRIER NAME:</span> {summary.carrier_name || 'N/A'}</div>
            </div>
        </div>
    );
};
